<template>
  <zm-button data-testid="checkout-button-479" :data-url='targetUrl' size='large' type="primary" round @click='goUser'>{{ ctaName }}</zm-button>
</template>
<script>
import { mapGetters } from 'vuex';
import { navigateToTargetPage } from '@/utils/modal-utils';
import { getEmailCTAsTrackingUrl } from '@/views/succezz/utils/email-ctas-tracking';

export default {
  props: {
    ctaName: String,
    isZp: Boolean,
    isZr: Boolean,
    isSeatManage: Boolean,
    utmContent: String
  },
  computed: {
    ...mapGetters(['successConfig']),
    targetUrl() {
      let url = getEmailCTAsTrackingUrl('/account/user', { utmContent: this.utmContent });
      if (this.isZp) {
        url = getEmailCTAsTrackingUrl('/pbx/page/telephone/phoneUsers#/users', { utmContent: this.utmContent });
      }
      if (this.isZr) {
        url = getEmailCTAsTrackingUrl('/location', { utmContent: this.utmContent });
      }
      if (this.isSeatManage) {
        url = this.successConfig.zeLink + '/e/billing/seats/'
      }
      return url;
    }
  },
  methods: {
    goUser() {
      this.$tracking.buyInteraction('purchase confirmation', this.ctaName?.toLowerCase?.());
      let url = '/account/user';
      if (this.isZp) {
        url = '/pbx/page/telephone/phoneUsers#/users';
      }
      if (this.isZr) {
        url = '/location'
      }
      if (this.isSeatManage) {
        url = this.successConfig.zeLink + '/e/billing/seats/'
      }

      navigateToTargetPage(url);
    }
  }
}
</script>
